/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';

const Link = ({
    openPage, language, page, subpage, routeState,
    className, id, children, callback, dangerousHTML, style, scroll, query, hash
}) => {
    const slashedPage = page ? `/${ page }` : '';
    const slashedSubpage = subpage ? `/${ subpage }` : '';
    const hashWithSign = hash ? `#${ hash }` : '';
    const linkClick = (e) => {
        e.preventDefault();
        openPage(page, subpage, routeState, language, scroll, query, hash);
        if (typeof callback === 'function') {
            callback();
        }
    };

    let queryString = '';
    if (Object.keys(query).length > 0) {
        Object.keys(query).forEach((key) => {
            const value = query[key] ? `=${ query[key] }` : '';
            if (queryString === '') {
                queryString = `?${ key }${ value }`;
            } else {
                queryString = `${ queryString }&${ key }${ value }`;
            }
        });
    }

    const isExternal = page && page.startsWith('http');

    return (
        dangerousHTML ? (
            isExternal ?
                <a
                  href={ page }
                  className={ className }
                  id={ id }
                  dangerouslySetInnerHTML={ { __html: dangerousHTML } }
                  style={ style }
                  target="_blank"
                  rel="noopener noreferrer"
                /> :
                <a
                  href={ `${ process.env.PUBLIC_URL }/${ language }${ slashedPage }${ slashedSubpage }${ queryString }${ hashWithSign }` }
                  className={ className }
                  id={ id }
                  onClick={ linkClick }
                  dangerouslySetInnerHTML={ { __html: dangerousHTML } }
                  style={ style }
                />
        ) : (
            isExternal ?
                <a
                  href={ page }
                  className={ className }
                  id={ id }
                  style={ style }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                    { children }
                </a> :
                <a
                  href={ `${ process.env.PUBLIC_URL }/${ language }${ slashedPage }${ slashedSubpage }${ queryString }${ hashWithSign }` }
                  className={ className }
                  id={ id }
                  onClick={ linkClick }
                  style={ style }
                >
                    { children }
                </a>
        )
    );
};

Link.defaultProps = {
    page: '',
    subpage: null,
    query: {},
    routeState: null,
    className: null,
    id: null,
    children: null,
    callback: null,
    dangerousHTML: null,
    style: null,
    scroll: true,
    hash: null
};

Link.propTypes = {
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string,
    subpage: PropTypes.string,
    query: PropTypes.objectOf(PropTypes.string),
    routeState: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    children: PropTypes.node,
    callback: PropTypes.func,
    dangerousHTML: PropTypes.string,
    style: PropTypes.shape(),
    scroll: PropTypes.bool,
    hash: PropTypes.string
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/helpers/Link.jsx